import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';
import { CtaButton } from '../styled';

const CurrencyHeroContainer = styled.div`
  background: #08111e;
  color: white;
  text-align: center;
  padding-top: 110px;
  padding-bottom: 90px;
`;

const MainImage = styled.div`
  img {
    height: 210px;
    margin-bottom: 40px;
  }
`;

const CurrencyName = styled.div`
  font-size: 48px;
  line-height: 48px;
  font-weight: 600;
`;

const Headline = styled.div`
  font-size: 24px;
  font-weight: 300;
  line-height: 32px;
  max-width: 474px;
  margin: 25px auto 25px;
`;

const SecondaryCTA = styled.div`
  margin: 25px auto;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  a {
    color: white;
    text-decoration: none;

    &:hover {
      color: #dddddd;
      cursor: pointer;
    }

    &:active {
      color: #aaaaaa;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

const FeatureSection = styled.div`
  max-width: 700px;
  margin: 0 auto;
  margin-top: 144px;

  img {
    height: 45px;
    margin-bottom: 20px;
  }
`;

function PlatformHero({ input }) {
  return (
    <CurrencyHeroContainer>
      <MainImage><img src={input.primary.image.url} /></MainImage>
      <CurrencyName>{input.primary.platform_name.text}</CurrencyName>
      <Headline>{input.primary.headline.text}</Headline>
    </CurrencyHeroContainer>
  );
}

/*
<div>
  <CtaButton type="button">{input.primary.cta_button_label.text}</CtaButton>
</div>
{input.primary.secondary_cta_link &&
  <SecondaryCTA>
    <a href={input.primary.secondary_cta_link.url} target="_blank" rel="noopener noreferrer">
      {input.primary.secondary_cta_label.text}
    </a>
  </SecondaryCTA>
}
<FeatureSection>
  <Grid columns={3} columnGap={'72px'} rowGap={'60px'}>
    {input.items.map((item, i) => {
      return (
        <Cell key={i} xs={3} sm={1}>
          <div><img src={item.feature_icon.url} /></div>
          <div>{item.feature_description.text}</div>
        </Cell>
      );
    })}
  </Grid>
</FeatureSection>
*/

export { PlatformHero };
